import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import ApiCalls from '../../custom-classes/api-calls';
import ListItem from '@material-ui/core/ListItem';

class SelectorUserPlanClasses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkedItems: new Map(),
            checkboxes : [],
            checkedValues: [],
            productsUserPlan: null
        };

        if(typeof props !== 'undefined' && typeof props.data !== 'undefined' && typeof props.data.productsUserPlan !== 'undefined')
        {
            this.state = {
                checkedItems: new Map(),
                checkboxes : [],
                checkedValues: props.data.productsSelected,
                productsUserPlan: props.data.productsUserPlan
            };
        }

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Sets the checked items in the first time
     */
    setCheckedItems(){
        for(let i=0; i < this.state.checkedValues.length;i++)
        {
            this.state.checkedItems.set(this.state.checkedValues[i], true);
        }
    }

    /**
     * Mounts the data. Call the data from the server and sets the data to the list
     */
    mountData(){

        if(this.state.productsUserPlan != null && this.state.productsUserPlan.length > 0)
        {
            let options = [];
            // Now fill the selections
            for (let i = 0; i < this.state.productsUserPlan.length; i++)
            {
                options.push({
                    name: this.state.productsUserPlan[i].ProductName,
                    key:   this.state.productsUserPlan[i].ProductId,
                    label:  this.state.productsUserPlan[i].ProductId,
                    checked: this.state.checkedValues.indexOf(this.state.productsUserPlan[i].ProductId) > -1
                })
            }

            this.setState({checkboxes:options});
        }
    }


    /**
     * Action when the component will mount
     */
    componentDidMount(){
        this.mountData();
        this.setCheckedItems();
    }

    /**
     * Removes a value from array
     * @param array
     * @param xToRemove
     * @returns {*}
     */
    removeFromArray(array, xToRemove){
        for(let i = array.length - 1; i >= 0; i--)
        {
            if(array[i] === xToRemove) {
                array.splice(i, 1);
            }
        }
        return array;
    }

    /**
     * Add a value to an array
     * @param array
     * @param xToAdd
     * @returns {*}
     */
    insertInArrayIfNotExists(array, xToAdd){
        if(array.includes(xToAdd))
            return array;
        else {
            array.push(xToAdd);
            return array;
        }

    }

    /**
     * Action when the checkbox changes
     * @param e
     */
    handleChange(e) {
        const isChecked = e.target.checked;
        const value = e.target.value;

        this.setState(prevState => ({checkedItems: prevState.checkedItems.set(value, isChecked) }),()=>{
            let newArray = [];
            if(this.state.checkedItems.get(value)) {
                newArray = this.insertInArrayIfNotExists(this.state.checkedValues, value);
            }
            else {
                newArray = this.removeFromArray(this.state.checkedValues, value);
            }

            this.setState({
                checkedValues: newArray
            },()=>{
                this.props.updateParent(this.state.checkedValues);
                return this.state.checkedValues;
            });
        });
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.state.checkboxes.map(item => (
                        <ListItem key={item.key} dense button>
                            <label key={item.key}>
                                {item.name}
                                <Checkbox name={item.name}
                                          value={item.key}
                                          checked={this.state.checkedItems.get(item.key)}
                                          onChange={this.handleChange} />
                            </label>
                        </ListItem>
                    ))
                }
            </React.Fragment>
        );
    }
}

export default SelectorUserPlanClasses;


// WEBPACK FOOTER //
// ./src/components/selectors/multi-selector-user-plan-classes.js